/*
 * fn: searchIncludes
 *
 * Searches a haystack for a needle
 *
 */
import { stripString } from './stripString'

export const searchIncludes = (needle: string, haystack: string) =>
  stripString(haystack).indexOf(stripString(needle)) !== -1
